import React from 'react';
import {
  Document, Page, Text, View, StyleSheet, Image, Link,
} from '@react-pdf/renderer';
import ReactGA from 'react-ga';
import TablePDF from './tablePDF';
import FormDetailsPDF from './formDetails';
import FontFamily from './fonts';
import Space from './space';
import NOCNpdfLogo from '../../assets/images/NOCNpdfLogo.png';


// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  fontSubtitle: {
    fontFamily: 'MuliRegular',
    fontSize: 12,
  },
  space: {
    height: 30,
  },
  link: {
    color: '#0076BE',
  },
});

// Create Document Component
const PDF = ({ formData = [], filterTable = [] }) => {
  // Register the Google Analytics event
  ReactGA.event({
    category: 'PDF',
    action: 'Saved Search',
    label: 'PDF View',
  });
  return (
    <Document file="Modules">
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <FontFamily>
            <Image src={NOCNpdfLogo} style={{ width: 100, height: 'auto' }} />
            <Space />
            <Text style={styles.fontSubtitle}>
              Confirmation of the categories to be renewed as well as the RT tests to be booked
            </Text>
            <Space />
            <TablePDF amount={filterTable[1]} catsList={filterTable[0]} />
            <Space />
            <FormDetailsPDF data={formData} />
            <Space />
            <View>
              <Text style={styles.fontSubtitle}>
                To book visit
                { ' ' }
                <Link
                  href="https://www.nocnjobcards.org/CPCS/cpcs-renewal-test/booking-my-test/"
                  style={styles.link}
                >
                  https://www.nocnjobcards.org/CPCS/cpcs-renewal-test/booking-my-test/
                </Link>
              </Text>
            </View>
          </FontFamily>
        </View>
      </Page>
    </Document>
  );
};


export default PDF;
